<script setup lang="ts">
import { ref } from 'vue';
import Textarea from 'primevue/textarea';
import type { Content } from '@apparatix/types/AccountProfiles';

type Props = {
  contents: Content<'blob'>;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'on:change', value: Content<'blob'>): void;
}>();

const model = ref(props.contents);

const onChange = () => emit('on:change', model.value);
</script>
<template>
  <Textarea
    v-model="model"
    rows="6"
    fluid
    auto-resize
    @value-change="onChange"
  />
</template>
